import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

interface CascadeRule {
  /** The parent value to watch for changes */
  watch: number | undefined;
  /** Form field names to clear when parent changes */
  clear: string[];
  /** Hook setters to call with undefined when parent changes */
  resetSetters: ((id: number | undefined) => void)[];
}

interface Props {
  rules: CascadeRule[];
}

/**
 * Invisible component that resets child form fields and hook state
 * when a parent dropdown value changes. Must be rendered inside a Form.
 */
const FilterCascadeReset: React.FC<Props> = ({ rules }) => {
  const { setValue } = useFormContext();
  const prevRef = useRef<Map<number, number | undefined>>(new Map());

  useEffect(() => {
    rules.forEach((rule, i) => {
      const prev = prevRef.current.get(i);
      const curr = rule.watch;

      // Reset children when parent value changes (skip initial mount)
      if (prev !== undefined && prev !== curr) {
        rule.clear.forEach((field) => setValue(field, undefined));
        rule.resetSetters.forEach((setter) => setter(undefined));
      }

      prevRef.current.set(i, curr);
    });
  });

  return null;
};

export default FilterCascadeReset;